import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

const invalidateProspectSubmissions = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: ['/prospect-submissions'] });
};

export const getProspectSubmissions = ({ config } = {}) =>
  queryOptions({
    queryKey: ['/prospect-submissions'],
    queryFn: async () => {
      const res = await axiosGet('/prospect-submissions');
      return res.data;
    },
    ...config,
  });

export const useCreateProspectSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data }) => axiosPost('/prospect-submissions', data),
    onSuccess: () => invalidateProspectSubmissions(queryClient),
  });
};

export const useUpdateProspectSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => axiosPut(`/prospect-submissions/${id}`, data),
    onSuccess: () => invalidateProspectSubmissions(queryClient),
  });
};

export const useApproveProspectSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => axiosPut(`/prospect-submissions/${id}/approve`, {}),
    onSuccess: () => invalidateProspectSubmissions(queryClient),
  });
};

export const useRevokeProspectSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => axiosPut(`/prospect-submissions/${id}/revoke`, {}),
    onSuccess: () => invalidateProspectSubmissions(queryClient),
  });
};

export const useDeleteProspectSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => axiosDelete(`/prospect-submissions/${id}`),
    onSuccess: () => invalidateProspectSubmissions(queryClient),
  });
};
